// Vue
import { VNodeData } from "vue";
import { mixins } from "vue-class-component";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

// Mixins
import { EventBus } from "@mgs/ci2019-common/src/mixins/event_bus/EventBus";

// template
import template from "./template.vue";

@Component({
  name: "SliderItemImg",
  mixins: [template],
})
export class SliderItemImg extends mixins(EventBus) {
  public mouseTouchPosition: number | null = null;

  @Prop({ default: true })
  public shouldNotify!: boolean;

  @Prop({ default: false })
  public active!: boolean;

  @Prop()
  public duration!: number;

  @Prop()
  public headlineTop!: number;

  @Prop()
  public text!: string;

  @Prop()
  public contentText!: string;

  @Prop()
  public thumbnail!: string;

  @Prop()
  public imgSrc!: string;

  @Prop()
  public bgSrc!: string;

  @Prop()
  public alt!: string;

  @Prop({ default: false })
  public lightbox!: boolean;

  @Prop()
  public openIcon!: string;

  public created() {
    if (this.shouldNotify) {
      this.dispatch("Slider", "registerSlide", [
        {
          active: this.active,
          duration: this.duration,
          text: this.text,
          component: "TeaserModuleSliderItemImg",
          props: {
            imgSrc: this.imgSrc,
            bgSrc: this.bgSrc,
            alt: this.alt,
            headlineTop: this.headlineTop,
            text: this.text,
            contentText: this.contentText,
            lightbox: this.lightbox,
            openIcon: this.openIcon,
          },
        },
      ]);
    }
  }

  public mounted() {}

  public destroyed() {}

  public handleMouseDown(e: MouseEvent) {
    if (!this.lightbox) return;

    this.mouseTouchPosition = e.clientX;
  }

  public handleMouseUp(e: MouseEvent) {
    if (!this.lightbox) return;

    const positionDifference = this.mouseTouchPosition! - e.clientX;

    if (positionDifference < 5 && positionDifference > -5) {
      this.$emit("lightbox", {
        imgSrc: this.imgSrc,
        bgSrc: this.bgSrc,
        title: this.text,
      });
    }
  }
}
